import { Spacer, FallbackWidth } from '../constant';

export const getArtworkLeftAndWidth = (
    parentRect?: DOMRect,
    slideRect?: DOMRect,
) => {
    const parentLeft = parentRect?.left ?? 0;
    const parentWidth = parentRect?.width ?? 320;

    const slideLeft = slideRect?.left ?? 0;
    const slideWidth = slideRect?.width ?? FallbackWidth;

    const leftPosition = slideLeft - parentLeft;
    const withMinimumLeftPosition = Math.max(Spacer, leftPosition);
    const withMaximumLeftPosition = Math.min(
        parentWidth - slideWidth - Spacer,
        withMinimumLeftPosition,
    );

    return { left: withMaximumLeftPosition, width: slideWidth };
};
